import { render, staticRenderFns } from "./Guests.vue?vue&type=template&id=5b230d49&scoped=true&"
import script from "./Guests.vue?vue&type=script&lang=js&"
export * from "./Guests.vue?vue&type=script&lang=js&"
import style0 from "./Guests.vue?vue&type=style&index=0&id=5b230d49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b230d49",
  null
  
)

export default component.exports